//lib
import React from "react";
import "firebase/compat/auth";
import classNames from "classnames";
import firebase from "firebase/compat/app";
import { Avatar, Box, Typography } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { HeaderStyled } from "./header.style";
import { Link } from "react-router-dom";

//src
import { getAppHeaderRoutes } from "./header.utils";
import { COLOUR_CONSTANT } from "../../utils/contants";
import { FlowSvg, LogoutIcon, Notes } from "../../utils/svg-components";
import TableActionMenu from "../table-action-menu/table-action-menu";
import { useLocation, useNavigate } from "react-router-dom";
import CreateCompanyModal from "../../pages/companies/create-company/create-company-modal";
import CreateProjectModal from "../../pages/projects-list/create-project-modal/create-project-modal";
import CreateContactModal from "../../pages/contacts/create-contact/create-contact-modal";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails, userPermissions } = useAuth();
  const [showModal, setShowModal] = React.useState(false);
  const [showGroupModal, setShowGroupModal] = React.useState(false);
  const [companyModal, showCompanyModal] = React.useState(false);
  const [contactModal, showContactModal] = React.useState(false);
  const activeRoute = location.pathname;
  const avatarInitials =
    userDetails?.fullName
      ?.split(" ")
      .map((name) => name[0]?.toUpperCase())
      .join("") || "U";

  const signOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Sign out error:", error);
      });
  };

  const logoutOption = {
    title: "Logout",
    value: "logout",
    onClick: signOut,
    icon: <LogoutIcon />,
  };

  const adminOption = {
    title: "Admin Console",
    value: "admin-console",
    onClick: () => navigate("/admin-console"),
    icon: <Notes />,
  };

  const menuOptions = [
    logoutOption,
    // only show the Admin Console if they have the "Admin" permission
    ...(userPermissions?.includes("Admin") ? [adminOption] : []),
  ];

  const APP_HEADER_ROUTES = getAppHeaderRoutes({
    navigate,
    userPermissions,
    setShowModal,
    setShowGroupModal,
    showCompanyModal,
    showContactModal,
  });
  return (
    <HeaderStyled>
      <nav className="navbar">
      <Link to={'/dashboards/user-dashboard'}>
      <FlowSvg />
      </Link>
        

        <div className="routes-menu-wrapper">
          <div className="routes">
            {APP_HEADER_ROUTES.map((x, index) => {
              const isRouteActive = activeRoute.includes(x.baseUrl);

              const tabContent = (
                <div className="tab-content">
                  <div>{x?.icon}</div>
                  <Typography variant={"body1"} sx={{ paddingTop: "1px" }}>
                    {x?.title}
                  </Typography>
                </div>
              );
              return (
                <Box
                  className={classNames({
                    active: isRouteActive,
                    "transparent-border": true,
                  })}
                  sx={{
                    "&:hover": {
                      bgcolor: COLOUR_CONSTANT.theme.lightPink,
                    },
                  }}
                  key={`${index}-route`}
                >
                  <div className="route-style" key={x?.title}>
                    <TableActionMenu
                      width={x?.menuWidth}
                      height={x?.menuHeight}
                      noBorder
                      options={x.options}
                      customIcon={tabContent}
                      position="center"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    />
                  </div>
                </Box>
              );
            })}
          </div>

          <div className="avatar-menu">
            <TableActionMenu
              noBorder
              width={170}
              options={menuOptions}
              position="left"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              customIcon={
                <Avatar className="avatar-style">{avatarInitials}</Avatar>
              }
            />
          </div>
        </div>
      </nav>

      {showModal && (
        <CreateProjectModal
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            if (activeRoute === "/projectsview/") window.location.reload();
          }}
        />
      )}
      {showGroupModal && (
        <CreateProjectModal
          isCreationGroupView={true} // Pass the flag for project group creation
          onClose={() => setShowGroupModal(false)}
          onSuccess={() => setShowGroupModal(false)}
        />
      )}

      {companyModal && (
        <CreateCompanyModal
          onClose={() => showCompanyModal(false)}
          onSuccess={() => {
            if (activeRoute === "/projectsview/") window.location.reload();
            setShowModal(false);
          }}
          isConfirming={false}
        />
      )}

      {contactModal && (
        <CreateContactModal
          onClose={() => showContactModal(false)}
          onSuccess={() => {
            if (activeRoute === "/contactsview/") window.location.reload();
            setShowModal(false);
          }}
        />
      )}
    </HeaderStyled>
  );
};

export default Header;
